/*
 * Model for the conversation transcript
 */

define(["backbone"], function (Backbone) {
  var ConversationTranscriptModel = {};

  ConversationTranscriptModel.conversationTurn = Backbone.Model.extend({
    defaults: {
      processedUtterance: "",
    },
  });

  ConversationTranscriptModel.conversationTranscript = Backbone.Collection.extend({
    model: ConversationTranscriptModel.conversationTurn,
  });

  return ConversationTranscriptModel;
});
